// src/components/project/SKIPER/Sidebar.jsx
import React from 'react';
import '../../../styles/components/_PresentationPage.scss';
export default function Sidebar() {
  return (
    <nav className="presentation-sidebar-nav">
      <ul>
        <li><a href="#story-content">Story</a></li>
        <li><a href="#why-antartica-content">Why Antarctica?</a></li>
        <li><a href="#prototipes-content">Prototypes</a></li>
      </ul>
    </nav>
  );
}
